import { styles } from "@components/PreviewPdf/PreviewPdf.style";
import { Document, Image, Page, Text, View } from "@react-pdf/renderer";
import { format } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";

const CreditNotePreviewPDF = ({
  creditNoteData,
  title,
  paymentInfo,
  companyId,
  offers,
}) => {
  const { t } = useTranslation();
  const devise = "€";

  const invoice = creditNoteData?.invoiceId;
  const items = invoice?.offers || [];

  return (
    <>
      <Document>
        <Page size="A4" style={styles.page}>
          {/* Header */}
          <View style={styles.header}>
            <Text style={styles.title}>{t(title) || "Avoir"}</Text>
            <View>
              <Text style={styles.invoiceNumber}>
                {t("invoice.credit.credit_note")} :{" "}
                {creditNoteData?.numeroCreditNote || "En attente"}
              </Text>
              <Text style={styles.date}>
                {format(
                  new Date(creditNoteData?.date || new Date()),
                  "dd/MM/yyyy"
                )}
              </Text>
            </View>
          </View>

          {/* Émetteur & Destinataire */}
          <View style={styles.twoColumns}>
            <View style={styles.column}>
              <Text style={styles.sectionTitle}>{t("invoice.emitter")}</Text>
              <Text>{creditNoteData?.companyId?.name}</Text>
              <Text>{creditNoteData?.companyId?.email}</Text>
              <Text>{creditNoteData?.companyId?.address}</Text>
            </View>
            <View style={styles.receiverColumn}>
              <Text style={styles.sectionTitle}>{t("invoice.receiver")}</Text>
              <Text>{creditNoteData?.clientId?.name}</Text>
              <Text>{creditNoteData?.clientId?.email}</Text>
              <Text>{creditNoteData?.clientId?.address}</Text>
            </View>
          </View>

          {/* Note */}
          {creditNoteData?.note && (
            <View style={{ marginBottom: 15 }}>
              <Text style={styles.sectionTitle}>{t("invoice.note")}</Text>
              <Text>{creditNoteData.note}</Text>
            </View>
          )}

          <View>
            <Text style={styles.sectionTitle}>{t("invoice.details")}</Text>
            <View style={styles.detailTable}>
              <View style={styles.tableRowHeader}>
                <Text style={styles.cell}>{t("invoice.description")}</Text>
                <Text style={styles.cell}>{t("invoice.unit_price")}</Text>
                <Text style={styles.cell}>{t("invoice.quantity")}</Text>
                <Text style={styles.cell}>{t("invoice.vat_percent")}</Text>
                <Text style={styles.cell}>{t("invoice.discount")}</Text>
                <Text style={styles.cell}>{t("invoice.total_ht")}</Text>
              </View>

              {items.map((item, idx) => {
                console.log("🚀 ~ item:2222", item);
                const offerDetail = offers?.find(
                  (o) => o?.data?._id === item?.idOffer
                )?.data;
                console.log("🚀 ~ offerDetail:111", offerDetail);

                const description =
                  offerDetail?.description || item.description || "-";
                const price = item.price || offerDetail?.price || 0;
                const quantity = item.quantity || 0;
                const TVA = item.TVA || 0;
                const reduction = item.reductionAmount || 0;

                const totalHT = price * quantity - reduction;

                return (
                  <View key={idx} style={styles.tableRow}>
                    <Text style={styles.cell}>
                      {item.description || description || "-"}
                    </Text>
                    <Text style={styles.cell}>
                      {price.toFixed(2)} {devise}
                    </Text>
                    <Text style={styles.cell}>{quantity}</Text>
                    <Text style={styles.cell}>{TVA}%</Text>
                    <Text style={styles.cell}>
                      {reduction.toFixed(2)} {devise}
                    </Text>
                    <Text style={styles.cell}>
                      {totalHT.toFixed(2)} {devise}
                    </Text>
                  </View>
                );
              })}
            </View>

            {/* Total à part */}
            <View
              style={{
                marginTop: 10,
                flexDirection: "row",
                justifyContent: "flex-end",
              }}>
              <Text
                style={{ fontWeight: "bold", fontSize: 12, marginRight: 10 }}>
                {t("invoice.total_credit")} :
              </Text>
              <Text style={{ fontSize: 12 }}>
                {creditNoteData?.creditAmount?.toFixed(2)} {devise}
              </Text>
            </View>
          </View>
          {/* Footer */}
          <View
            style={{
              marginTop: 50,
              borderTopWidth: 1,
              borderTopColor: "#ccc",
              paddingTop: 10,
            }}>
            <Text style={styles.sectionTitle}>{t("invoice.conditions")}</Text>
            <Text>
              <Text style={styles.bold}>{t("invoice.payment_method")} :</Text>{" "}
              {invoice?.paymentStatus || t("invoice.no_payment_method")}
            </Text>

            {paymentInfo && (
              <View style={{ marginTop: 10 }}>
                <Text style={styles.sectionTitle}>
                  {t("invoice.bank_info")}
                </Text>
                <Text>
                  {t("invoice.bank")}: {paymentInfo?.name || ""}
                </Text>
                <Text>
                  {t("invoice.iban")}: {paymentInfo?.iban || ""}
                </Text>
                <Text>
                  {t("invoice.bic")}: {paymentInfo?.bic || ""}
                </Text>
                <Text>
                  {t("invoice.rib")}: {paymentInfo?.rib || ""}
                </Text>
              </View>
            )}

            <View
              style={{
                marginTop: 10,
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}>
              <Image src="/logo.png" style={{ width: 80, height: 40 }} />
              <Text style={{ fontSize: 9, color: "#555" }}>
                {t("invoice.company_signature")}
              </Text>
            </View>

            <Text
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
              style={{
                marginTop: 5,
                fontSize: 9,
                color: "#999",
                textAlign: "right",
              }}
            />
          </View>
        </Page>
      </Document>
    </>
  );
};

export default CreditNotePreviewPDF;
